import React from "react";
import Flagship from "../../core/flagship";
import {
  Segment,
  Button,
  Icon,
  Header,
  Portal,
  Image
} from "semantic-ui-react";
import { bindActionCreators } from "redux";
import { Link } from "react-router";
import moment from "moment-business-days";
import * as actions from "../../actions/appActions";
import connect from "react-redux/es/connect/connect";
import ClientPickModal from "../modals/ClientPickModal";
import TaskPickModal from "../modals/TaskPickModal";

const TimeTracker = props => {
  const trackTime = () => {
    props.actions.trackTime(props.userId, props.timeRecorded);
    toggleVisibility();

    let data = {
      user: props.userId,
      client:
        props.timerClient === null
          ? props.timerDefaultClient
          : props.timerClient,
      task: props.timerTask
    };

    if (props.timerClient === null)
      props.actions.pickClient(props.timerDefaultClient);

    Flagship.post("timesheets/timer", data);
    Flagship.notify("Timer started.", "info");
  };

  const stopTrackTime = () => {
    props.actions.stopTrackTime();
    Flagship.post("timesheets/timer/stop", {
      user: props.userId,
      banked: props.timeRecorded
    });
    Flagship.notify("Timer stopped.", "info");
  };

  const clearTime = () => {
    Flagship.post("timesheets/timer/clear", {
      user: props.userId
    });
    props.actions.clearTime();
  };

  const pickClient = () => {
    props.actions.toggleClientPicker(true);
  };

  const onSelectClient = client => {
    props.actions.pickClient(client);
    props.actions.toggleClientPicker(false);

    // Update saved timer (if it exists)
    let data = {
      user: props.userId,
      client: client,
      task: props.timerTask
    };

    Flagship.post("timesheets/timer/update", data);
  };

  const cancelPickClient = () => {
    props.actions.toggleClientPicker(false);
  };

  const pickTask = () => {
    props.actions.toggleTaskPicker(true);
  };

  const onSelectTask = task => {
    props.actions.pickTask(task);
    props.actions.toggleTaskPicker(false);

    // Update saved timer (if it exists)
    let data = {
      user: props.userId,
      client: props.timerClient,
      task: task
    };

    Flagship.post("timesheets/timer/update", data);
  };

  const cancelPickTask = () => {
    props.actions.toggleTaskPicker(false);
  };

  const toggleVisibility = () => {
    props.actions.toggleTimeTracker();
  };

  const clientText = () => {
    let defaultClientName = "No Client";

    if (
      props.timeRecorded === 0 &&
      props.timerDefaultClient !== null &&
      props.timerDefaultClient.hasOwnProperty("name")
    ) {
      defaultClientName = props.timerDefaultClient.name;
    }

    return props.timerClient !== null &&
      props.timerClient.hasOwnProperty("name") &&
      typeof props.timerClient.name !== "undefined"
      ? props.timerClient.name
      : defaultClientName;
  };

  const renderTimerTitle = length => {
    let text = "";

    text +=
      typeof props.timerTask !== "undefined" && props.timerTask !== null
        ? props.timerTask
        : "New Timer";
    text += " - ";
    text += clientText();

    text = text.substring(0, length) + (text.length > length ? "..." : "");

    return <span className="timer-title">{text}</span>;
  };

  return (
    <div>
      {props.timerVisible && props.windowBlur !== true ? (
        <Portal className="flagship-time-tracker" open>
          <Segment.Group
            style={{
              position: "fixed",
              bottom: ".5em",
              right: ".5em",
              zIndex: 1000
            }}
          >
            <Segment
              className={
                (props.timerRunning ? "tracker-running" : "tracker-stopped") +
                " tracker-top"
              }
            >
              <Icon
                color="black"
                name="clock"
                size="large"
                className="tracker-clock-icon"
              />
              <strong className="time-tracker-heading">
                {props.timeRecordedFormatted}
              </strong>
              <Icon
                className="minimize-tracker float-right"
                size="small"
                name="minus"
                circular
                inverted
                onClick={toggleVisibility}
              />
            </Segment>
            <Segment
              className={
                props.timerRunning ? "tracker-running" : "tracker-stopped"
              }
            >
              <Header>
                <span
                  style={{ display: "table-cell", verticalAlign: "bottom" }}
                >
                  {renderTimerTitle(64)}
                </span>
              </Header>

              <div>
                {props.timeRecorded > 0 && !props.timerRunning ? (
                  <Button onClick={clearTime}>
                    <Icon name="cancel" />
                    Clear Timer
                  </Button>
                ) : null}

                {(props.timeRecorded > 0 && props.timerRunning) ||
                (props.timeRecorded <= 0 && !props.timerRunning) ? (
                  <Button onClick={pickTask}>
                    <Icon name="tasks" />
                    {props.timerTask !== null ? "Swap" : "Pick "} Category...
                  </Button>
                ) : null}

                {(props.timeRecorded > 0 && props.timerRunning) ||
                (props.timeRecorded <= 0 && !props.timerRunning) ? (
                  <Button onClick={pickClient}>
                    <Icon name="briefcase" />
                    {props.timerClient !== null &&
                    typeof props.timerClient !== "undefined"
                      ? "Swap"
                      : "Pick "}{" "}
                    Client...
                  </Button>
                ) : null}

                {props.timeRecorded > 0 &&
                !props.route.hasOwnProperty("fromTimer") &&
                !props.timerRunning ? (
                  <Button
                    as={Link}
                    className="add-time-entry-button"
                    to={
                      "/time/date/" +
                      moment(new Date()).format("MM-DD-YYYY") +
                      "/add/timer"
                    }
                  >
                    <Icon name="plus" />
                    Add Time Entry
                  </Button>
                ) : null}

                {props.timerRunning ? (
                  <Button onClick={stopTrackTime} className="tracker-primary">
                    <Icon name="pause" />
                    Pause Timer
                  </Button>
                ) : (
                  <Button onClick={trackTime} className="tracker-primary">
                    <Icon name="play" />
                    {props.timeRecorded > 0
                      ? "Resume Timer..."
                      : "Start Timer..."}
                  </Button>
                )}
              </div>
            </Segment>
          </Segment.Group>
        </Portal>
      ) : (
        <Portal className="flagship-time-tracker minimized" open>
          {props.timerRunning ? (
            <Segment
              circular
              size="mini"
              onClick={toggleVisibility}
              style={{
                position: "fixed",
                bottom: "16px",
                right: "1em",
                zIndex: 1000
              }}
              className="tracker-running"
            >
              <Image src="/assets/clock.svg" />
            </Segment>
          ) : (
            <Segment
              circular
              size="mini"
              onClick={toggleVisibility}
              style={{
                position: "fixed",
                bottom: "16px",
                right: "1em",
                zIndex: 1000
              }}
              className="tracker-stopped"
            >
              <Image src="/assets/clock-still.svg" />
            </Segment>
          )}
        </Portal>
      )}
      <ClientPickModal
        open={props.pickingClient}
        onSelectClient={onSelectClient}
        cancelSelect={cancelPickClient}
        default={props.timerDefaultClient}
      />

      <TaskPickModal
        open={props.pickingTask}
        onSelectTask={onSelectTask}
        cancelSelect={cancelPickTask}
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    token: state.main.token,
    userId: state.main.userId,
    timerVisible: state.time.timerVisible,
    timerRunning: state.time.timerRunning,
    timeRecorded: state.time.timeRecorded,
    timeRecordedFormatted: state.time.timeRecordedFormatted,
    pickingClient: state.time.pickingClient,
    pickingTask: state.time.pickingTask,
    timerClient: state.time.timerClient,
    timerDefaultClient: state.time.timerDefaultClient,
    timerTask: state.time.timerTask,
    windowBlur: state.time.windowBlur
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TimeTracker);



// WEBPACK FOOTER //
// ./src/components/misc/TimeTracker.js